// IntersectionObserver 기반 뷰포트 진입 감지 훅
// 사용: <div ref={ref} className={'ug-reveal ' + (visible ? 'visible' : '')}>
import { useEffect, useRef, useState } from 'react';

export default function useScrollReveal(options) {
  var opts = options || {};
  var threshold = typeof opts.threshold === 'number' ? opts.threshold : 0.15;
  var once = opts.once !== false; // 기본 한 번만
  var ref = useRef(null);
  var _vs = useState(false);
  var visible = _vs[0];
  var setVisible = _vs[1];

  useEffect(function () {
    var el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setVisible(true);
          if (once) io.unobserve(el);
        } else if (!once) {
          setVisible(false);
        }
      });
    }, { threshold: threshold });
    io.observe(el);
    return function () { io.disconnect(); };
  }, []);

  return { ref: ref, visible: visible };
}
